import React, { useEffect, useState } from "react";
import { Input, Row, Col } from "antd";
import { success, error } from "../contants/snackbars";
import {
  LoadingButton,
  PrimaryButton,
} from "../custom_components/customButton";
import { editSiteSetting, fetchSiteSetting } from "../stores/api_calls/about";
import { colorScheme } from "../contants/variables";

const SiteSetting= () => {
  const [form, setForm] = useState({
    loan_percent: 0,
    interest_rate_percent: 0,
    loan_transfer_fee: 0,
    id: "68240f5ae98421c57a0a5a43",
  });

  const [requestLoading, setRequestLoading] = useState(false);

  useEffect(() => {
    getContent();
  }, []);

  const getContent = () => {
    const updateContent = fetchSiteSetting({ id: "68240f5ae98421c57a0a5a43" });
    updateContent
      .then((res) => {
        if (res.data.success) {
            const result = res.data.data;
            setForm({ 
                ...form, 
                loan_percent: result.loan_percent,
                interest_rate_percent: result.interest_rate_percent,
                loan_transfer_fee: result.loan_transfer_fee,
            });
        }
      })
      .catch((e) => {
        error("Failed to retrieve content");
      });
  };

  const handleFieldChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.value,
    });
  };

  const onSubmit = () => {
    setRequestLoading(true);

    const updateContent = editSiteSetting(form);
    updateContent
      .then((res) => {
        if (res.data.success) {
          success("Successfully updated");
          setRequestLoading(false);
        }
      })
      .catch((e) => {
        error("Failed to save changes");
        setRequestLoading(false);
      });
  };

  return (
    <div>
      <h1>Site Settings</h1>
      <Row>
        <Col xs={24} sm={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Loan % <span>*</span> :{" "}
            </p>
            <Input
              value={form.loan_percent}
              onChange={(val) => handleFieldChange("loan_percent", val)}
            />
          </div>
        </Col>
        <Col xs={24} sm={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Interest Rate % <span>*</span> :{" "}
            </p>
            <Input
              value={form.interest_rate_percent}
              onChange={(val) => handleFieldChange("interest_rate_percent", val)}
            />
          </div>
        </Col>
        <Col xs={24} sm={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Transfer Fee <span>*</span> :{" "}
            </p>
            <Input
              value={form.loan_transfer_fee}
              onChange={(val) => handleFieldChange("loan_transfer_fee", val)}
            />
          </div>
        </Col>

        
      </Row>

      <div className="btn-div" style={{ marginTop: 15 }}>
        <div className="btn" style={{width:'180px',}}>
          {requestLoading ? (
            <LoadingButton />
          ) : (
            <PrimaryButton
              label="Save Changes"
              color={colorScheme.primary}
              onClick={() => onSubmit()}
              disabled={!form.loan_percent && !form.interest_rate_percent && !form.loan_transfer_fee}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SiteSetting;
